export default __webpack_public_path__ + "static/media/check-solid.5dcf9568.svg";